<div class="item">
    <div class="grid-row item_group">
        <label class="item_label">PO</label>
       <label class="item_label">Invoice Number</label>
        <label class="item_label">Expected Date</label>
        <label class="item_label">Pieces</label>
    </div>
    <div class="grid-row item_group" *ngFor="let item of breakdown">
        <span class="purchase-order item_value">{{item.purchaseOrderId}}</span>
       <span class="purchase-order item_value" [matTooltip]= "item.poNumber">{{item.poNumber}}</span>
        <span class="item_value">{{item.expectedOn | date:'MM/dd/yy'}}</span>
        <span class="item_value">{{item.outstandingQty}}</span>
    </div>
</div>
